module.exports = __webpack_public_path__ + "media/images/learn-grow-15b20a812825c36818d2bf6426c6f6f1.png";